import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { RetellingLoader } from '../helpers/ai/retelling/RetellingLoader';
import { RetellingViewer } from '../helpers/ai/retelling/RetellingViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const Retelling = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.RETELLING.lightIcon : AI_UTILITIES.RETELLING.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.RETELLING.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.RETELLING.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.RETELLING.path} component={RetellingLoader} />
                <Route path={`${AI_UTILITIES.RETELLING.path}/:inputIdentifier`} component={RetellingViewer} />
            </Switch>
        </div>
    );
};

Retelling.displayName = 'Retelling';